export default "__VITE_ASSET__DGSm0oHA__"